export enum PaymentConditionEnum {
    FLEXIBLE = 1,
    FIXED = 2
}